// extracted by css-extract-rspack-plugin
export default {"cls1":"common-cls1_bHS","cls2":"common-cls2_f0u common-cls1_bHS"};